<template>
    <div class="header row justify-space-between align-center px-2 header-scroll">
        <slot name="header">
            <div class="item-header">
                <slot name="before">
                    <DxButton
                        class="custom-btn-white-color"
                        type="default"
                        icon="mdi mdi-chevron-left"
                        @click="$router.go(-1)"
                    />
                </slot>
            </div>
            <div class="item-header-center row justify-center">
                <slot name="center">
                    <div class="font-16 font-medium color-fff">
                        {{ Title }}
                    </div>
                </slot>
            </div>
            <div class="item-header">
                <slot name="after">
                    <div style="opacity: 0">
                        <DxButton type="default" icon="mdi mdi-chevron-left" />
                    </div>
                </slot>
            </div>
        </slot>
    </div>
</template>
<script>
import { DxButton } from "devextreme-vue/";
export default {
    components: { DxButton },
    props: {
        Title: { type: String, default: "" },
    },
    data() {
        return {};
    },
    created() {},
    methods: {},
    mounted() {},
};
</script>
<style scoped>
.header {
    width: 100vw;
    min-height: 48px;
    background: #03a9f4;
}
.header-scroll {
    position: fixed;
    top: 0;
    z-index: 100;
}

::v-deep .custom-btn-white-color i.dx-icon {
    color: white;
}
.item-header-center {
    position: absolute;
    left: 0;
    z-index: 1;
}
.item-header {
    position: relative;
    z-index: 2;
}
</style>
